import { API_ROUTES } from "@shared/contracts";

/**
 * The service's endpoint paths — what the api/ hooks pass as `serviceName` to
 * the CRUD hooks. Always derived from `API_ROUTES`, never hand-written path
 * strings.
 */
export const AUTH_LOGIN_SERVICE_NAME = API_ROUTES.AUTH.login();

/** Reached with **GET** — see `useLogoutApi`. */
export const AUTH_LOGOUT_SERVICE_NAME = API_ROUTES.AUTH.logout();

export const AUTH_REFRESH_SERVICE_NAME = API_ROUTES.AUTH.refresh();

export const AUTH_REQUEST_RESET_PASSWORD_SERVICE_NAME =
  API_ROUTES.AUTH.requestResetPassword();

export const AUTH_VALIDATE_RESET_PASSWORD_CODE_SERVICE_NAME =
  API_ROUTES.AUTH.validateResetPasswordCode();

export const AUTH_RESET_PASSWORD_SERVICE_NAME = API_ROUTES.AUTH.resetPassword();
